interface SessionData {
  page: string;
  data: any;
  timestamp: number;
}

const SESSION_RECOVERY_KEY = 'cassette_session_recovery';

export const saveSessionData = (page: string, data: any) => {
  try {
    const sessionData: SessionData = {
      page,
      data,
      timestamp: Date.now()
    };
    sessionStorage.setItem(SESSION_RECOVERY_KEY, JSON.stringify(sessionData));
  } catch (error) {
    console.error('Failed to save session data', error);
  }
};

export const getSessionData = (): SessionData | null => {
  try {
    const data = sessionStorage.getItem(SESSION_RECOVERY_KEY);
    if (!data) return null;
    
    const sessionData: SessionData = JSON.parse(data);
    
    // Check if data is older than 1 hour
    const oneHour = 60 * 60 * 1000;
    if (Date.now() - sessionData.timestamp > oneHour) {
      sessionStorage.removeItem(SESSION_RECOVERY_KEY);
      return null;
    }
    
    return sessionData;
  } catch (error) {
    console.error('Failed to get session data', error);
    return null;
  }
};

export const clearSessionData = () => {
  try {
    sessionStorage.removeItem(SESSION_RECOVERY_KEY);
  } catch (error) {
    console.error('Failed to clear session data', error);
  }
};

export const hasSessionData = (): boolean => {
  return getSessionData() !== null;
}; 